'use strict';

const constants = {
    BASE_URL: 'https://storage.googleapis.com/trustville-widgets/product/c_3820/',
    STARS: '/prod/stars.html',
    FEEDBACKS: '/prod/feedbacks.html'
};

/**
 * @param {string} page - page type
 * @returns {void} - void
 */
function fetchProductsRatingHtml(page) {
    const elements = document.getElementsByClassName('wizville-stars');
    let blockElement = document.getElementById('block-reviews');

    Array.prototype.forEach.call(elements, async function (element) {
        let productId = element.getAttribute('data-product-id');

        if (productId !== 'null') {
            let starsUrl = constants.BASE_URL + productId + constants.STARS;
            let starsResponse = await fetch(starsUrl);
            let starsResponseText = await starsResponse.text();

            if (starsResponse.status === 200) {
                element.innerHTML = starsResponseText;

                if (page === 'detail' && blockElement) {
                    await fetchProductsReviewsHtml(productId);
                }
            }
        }
    });
}

/**
 * @param {string} productId - productId
 * @returns {void} - void
 */
async function fetchProductsReviewsHtml(productId) {
    let feedbacksUrl = constants.BASE_URL + productId + constants.FEEDBACKS;
    let feedbacksResponse = await fetch(feedbacksUrl);
    let feedbacksResponseText = await feedbacksResponse.text();

    let blockElement = document.getElementById('block-reviews');
    let containerElement = document.getElementById('container-feedbacks');
    blockElement.style.display = 'block';
    containerElement.innerHTML = feedbacksResponseText;

    let scripts = containerElement.querySelectorAll('script');

    scripts.forEach(oldScript => {
        let newScript = document.createElement('script');
        if (oldScript.src) {
            newScript.src = oldScript.src;
        } else {
            newScript.textContent = oldScript.textContent;
        }

        document.body.appendChild(newScript);
    });

    $('#detail-product-reviews').on('click', function (e) {
        e.preventDefault();
        $('#reviewsPanelCollapse').collapse('show');
        document.getElementById('accordionProductDetails').scrollIntoView({ behavior: 'smooth' });
    });
}
module.exports = {
    fetchProductsRatingHtml: fetchProductsRatingHtml
};
